import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=5db7fa65&scoped=true"
import script from "./Page4.vue?vue&type=script&lang=js"
export * from "./Page4.vue?vue&type=script&lang=js"
import style0 from "./Page4.vue?vue&type=style&index=0&id=5db7fa65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7fa65",
  null
  
)

export default component.exports